<template>
  <div class="process-steps-wrapper">
    <el-steps :space="200" :active="curStep" finish-status="success" class="process-steps">
      <el-step title="购物车" />
      <el-step title="确认订单" />
      <el-step title="等待发货" />
      <el-step title="已发货" />
      <el-step title="已签收" />
    </el-steps>
  </div>

</template>

<script>
export default {
  name: 'PurchaseStes',
  props: {
    curStep: {
      type: Number,
      default: 0
    }
  },
}
</script>

<style lang="scss" scoped>
.process-steps-wrapper {
  padding: 0;
  margin: 0 0 20px 0;
  .process-steps {
    width: 400px;
    margin: 0 auto;
  }
}

</style>
